var _path, _path2, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.511,
    height: 44.512,
    viewBox: "0 0 44.511 44.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M17.267,5.838A11.421,11.421,0,1,0,28.688,17.259,11.42,11.42,0,0,0,17.267,5.838Zm0,18.834a7.413,7.413,0,1,1,7.413-7.413A7.411,7.411,0,0,1,17.267,24.672Z",
    transform: "translate(4.997 4.988)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M31.432.14c-4.1-.191-14.238-.182-18.337,0-3.6.169-6.779,1.039-9.34,3.6C-.525,8.021.022,13.789.022,22.248c0,8.657-.482,14.292,3.733,18.507,4.3,4.3,10.149,3.733,18.507,3.733,8.576,0,11.536.006,14.568-1.168,4.123-1.6,7.235-5.286,7.539-11.9.193-4.1.182-14.238,0-18.337C44,5.265,39.81.526,31.432.14Zm6.482,37.782c-2.806,2.806-6.7,2.556-15.7,2.556-9.273,0-12.992.137-15.7-2.583-3.125-3.11-2.559-8.1-2.559-15.677,0-10.247-1.052-17.626,9.232-18.153,2.363-.083,3.058-.111,9.006-.111l.083.056c9.883,0,17.638-1.035,18.1,9.247.106,2.346.13,3.051.13,8.989C40.5,31.411,40.672,35.152,37.914,37.923Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 2.669,
    cy: 2.669,
    r: 2.669,
    transform: "translate(31.468 7.707)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a385400372091fe9e24c6419e8de88f3.svg";
export { ForwardRef as ReactComponent };